import { createLazyDuckDb } from './index';

/**
 * The database every dataset-preview surface materialises into.
 *
 * One handle, shared, so the preview table and the overlays that join against
 * it land in the same database — a join cannot cross two DuckDB-wasm workers.
 * It lives here rather than on the dataset page because the modules that need
 * it (materialization, stats, the automations side table) are the page's
 * dependencies, and importing it back from the page would make the graph
 * circular.
 *
 * Lazy: the wasm bundle is only fetched once something actually awaits this.
 */
export const datasetPreviewDuckDb = createLazyDuckDb();
